import React from 'react';
import logo from '../images/crms/ghl.png';

// Render the official GoHighLevel logo asset stored at
// src/assets/images/crms/ghl.png. Kept as a React component (rather than
// importing the image directly into SourceIcon) so the icon barrel stays
// the single source of truth for what represents each source.
function GHL(props) {
    const className = props.className;
    return (
        <img
            src={logo}
            alt=""
            className={className}
            style={{ width: '130%', height: '130%', objectFit: 'contain' }}
        />
    );
}

export default GHL;
